// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags
import moment from 'moment';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Note extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get display() {
        return [`(${moment(this.created).format('MM/DD/yyyy h:mma')})`, `${this.createdBy.displayName}:`, this.text].join('  ');
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdById!: number;
  deleted?: Date;
  entityId!: number;
  entityTypeName?: string;
  text?: string;
  createdBy!: User;
}

